import { useEffect, useRef, useState } from "react";
import { Controller } from "react-hook-form";

function FormInput({
  control,
  userData,
  name,
  type,
  icon,
  isPassword = false,
  isConfirmPassword = false,
  iconPasswordVisible,
  iconPasswordHidden,
  iconStyle,
  errors,
  label,
  cardIcon,
  ...props
}) {
  const [value, setValue] = useState("");

  useEffect(() => {
    if (userData?.data?.[name]) {
      setValue(userData?.data?.[name]);
    }
  }, [userData, name]);
  const [isPasswordVisible, setIsPasswordVisible] = useState(false);
  const togglePasswordVisibility = () => {
    setIsPasswordVisible(!isPasswordVisible);
  };
  const inputRef = useRef(null);

  const handleFocusInput = () => {
    if (inputRef.current) {
      inputRef.current.focus();
    }
  };

  return (
    <>
      <div className="relative">
        <Controller
          control={control}
          name={name}
          defaultValue={value}
          rules={{ required: `${label} is required` }}
          render={({ field }) => (
            <input
              className="mb-1 px-12 lg:px-16 2xl:px-20 text-sm lg:text-lg font-ralewaySemiBold text-customBlack  w-full py-5 rounded-xl focus:outline-none transition duration-300 delay-100 focus:ring-2 focus:ring-primary shadow-custom-gray"
              type={
                isPassword ? (isPasswordVisible ? "text" : "password") : type
              }
              {...field}
              {...props}
              value={value}
              onChange={(e) => {
                setValue(e.target.value);
                field.onChange(e);
              }}
              ref={inputRef}
            />
          )}
        />
        <div>
          {icon && (
            <img
              onClick={handleFocusInput}
              className={`absolute left-5 2xl:left-8 top-1/2 transform -translate-y-1/2 ${iconStyle}`}
              src={icon}
              alt={`${name} icon`}
            />
          )}
          {cardIcon && (
            <img
              onClick={handleFocusInput}
              className={`absolute right-6 top-1/2 transform -translate-y-1/2 w-7 h-4 lg:h-6 lg:w-10 2xl:right-8 2xl:w-9 2xl:h-8`}
              src={cardIcon}
              alt={`${name} cardIcon`}
            />
          )}
          {(isPassword || isConfirmPassword) && (
            <img
              className="absolute right-5 top-1/2 transform -translate-y-1/2 w-5 h-5 lg:h-6 lg:w-7 cursor-pointer 2xl:right-8 2xl:w-8 2xl:h-7"
              src={isPasswordVisible ? iconPasswordVisible : iconPasswordHidden}
              alt={isPasswordVisible ? "Show password" : "Hide password"}
              onClick={togglePasswordVisibility}
            />
          )}
        </div>
      </div>
      <div>
        {errors[name] && (
          <span style={{ color: "red" }}>{errors[name].message}</span>
        )}
      </div>
    </>
  );
}

export default FormInput;
